<template>
<v-facebook-login class="facebook-login-button" app-id="628759089050558" 
style="height: 100%" @login="login">
    <svg slot="working" width="24" height="24" stroke="#000" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g>
        <circle cx="12" cy="12" r="9.5" fill="none" stroke-width="3" stroke-linecap="round" stroke="white">
          <animate attributeName="stroke-dasharray" dur="1.5s" calcMode="spline" values="0 150;42 150;42 150;42 150" keyTimes="0;0.475;0.95;1" keySplines="0.42,0,0.58,1;0.42,0,0.58,1;0.42,0,0.58,1" repeatCount="indefinite"/>
          <animate attributeName="stroke-dashoffset" dur="1.5s" calcMode="spline" values="0;-16;-59;-59" keyTimes="0;0.475;0.95;1" keySplines="0.42,0,0.58,1;0.42,0,0.58,1;0.42,0,0.58,1" repeatCount="indefinite"/>
        </circle>
        <animateTransform attributeName="transform" type="rotate" dur="2s" values="0 12 12;360 12 12" repeatCount="indefinite"/>
      </g>
    </svg>
    <span :class="{'login-slot':loginSlot}" slot="login">{{ loginSlot }}</span>
    <span slot="logout">Salir</span>
</v-facebook-login>
</template>

<script>
import VFacebookLogin from 'vue-facebook-login-component'
export default {
    components: {
      VFacebookLogin,
    },
    props: {
      'login-slot': { 
        type: String,
        default: ''
      }
    },
    methods: {
      login(response) {
        if(response)
          this.$cookies.set("fb_login_id", response.authResponse.userID)
      }
    }
  }
</script>

<style scoped>
.v-facebook-login {
  cursor: pointer;
}
.v-facebook-login .login-slot {
  padding-left: .5rem;
}
</style>
<style>
.v-facebook-login .logo {
  margin-right: 0;
}
</style>